var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 38,
    height: 38,
    rx: 17,
    fill: "#071E3B",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 28.5065C19.5 28.7828 19.7242 29.0081 20.0002 28.9945C25.2939 28.7339 29.5059 24.3593 29.5059 19.001C29.5059 13.4749 25.026 8.99512 19.5 8.99512C13.9739 8.99512 9.49414 13.4749 9.49414 19.001C9.49414 23.6288 12.6359 27.5228 16.9028 28.6664C17.2083 28.7484 17.4988 28.5109 17.4988 28.1947V21.0022H16.4982C15.9456 21.0022 15.4977 20.5542 15.4977 20.0016C15.4977 19.4489 15.9456 19.001 16.4982 19.001H17.4988V16.9998C17.4988 15.342 18.8427 13.998 20.5006 13.998H21.5012C22.0538 13.998 22.5018 14.446 22.5018 14.9986C22.5018 15.5512 22.0538 15.9992 21.5012 15.9992H20.5006C19.948 15.9992 19.5 16.4472 19.5 16.9998V19.001H21.5012C22.0538 19.001 22.5018 19.4489 22.5018 20.0016C22.5018 20.5542 22.0538 21.0022 21.5012 21.0022H19.5V28.5065Z",
    fill: "#145DA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4af5b884e36b1969772eaad6c8b9a56a.svg";
export { ForwardRef as ReactComponent };